import AdminAreasManager from "@/components/admin/AdminAreasManager";
import AdminCitiesManager from "@/components/admin/AdminCitiesManager";
import AdminLocationsQueue from "@/components/admin/AdminLocationsQueue";
import { router } from "expo-router";
import React, { useState } from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

type TabKey = "cities" | "areas" | "pending";

export default function AdminLocationsHome() {
  const [tab, setTab] = useState<TabKey>("cities");

  return (
    <SafeAreaView edges={["top"]} style={styles.safe}>
      <View style={styles.container}>
        <View style={styles.header}>
          <Pressable
            onPress={() => router.push("/admin" as any)}
            style={styles.backButton}
          >
            <Text style={styles.backButtonText}>← Admin Dashboard</Text>
          </Pressable>

          <Text style={styles.h1}>Admin · Locations</Text>
        </View>

        <View style={styles.tabs}>
          <TabButton
            label="Cities"
            active={tab === "cities"}
            onPress={() => setTab("cities")}
          />

          <TabButton
            label="Areas"
            active={tab === "areas"}
            onPress={() => setTab("areas")}
          />

          <TabButton
            label="Pending"
            active={tab === "pending"}
            onPress={() => setTab("pending")}
          />
        </View>

        <View style={{ flex: 1 }}>
          {tab === "cities" ? <AdminCitiesManager /> : null}
          {tab === "areas" ? <AdminAreasManager /> : null}
          {tab === "pending" ? <AdminLocationsQueue /> : null}
        </View>
      </View>
    </SafeAreaView>
  );
}

function TabButton({
  label,
  active,
  onPress,
}: {
  label: string;
  active: boolean;
  onPress: () => void;
}) {
  return (
    <Pressable
      onPress={onPress}
      style={[styles.tabBtn, active && styles.tabBtnActive]}
    >
      <Text style={[styles.tabText, active && styles.tabTextActive]}>
        {label}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: "#fff",
  },

  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 10,
    backgroundColor: "#fff",
  },

  header: {
    marginBottom: 12,
  },

  backButton: {
    alignSelf: "flex-start",
    marginBottom: 8,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 999,
    backgroundColor: "#F3F4F6",
  },

  backButtonText: {
    fontSize: 13,
    fontWeight: "900",
    color: "#111827",
  },

  h1: {
    fontSize: 22,
    fontWeight: "900",
  },

  tabs: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
  },

  tabBtn: {
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: "#fafafa",
  },

  tabBtnActive: {
    backgroundColor: "#111",
    borderColor: "#111",
  },

  tabText: {
    fontWeight: "900",
  },

  tabTextActive: {
    color: "white",
  },
});